import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../catalog/config/component.config';
import { NCmsComponentImage } from './cms-component-image.interface';

export const CMS_COMPONENT_IMAGE_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentImage.ID,
    isAdvanced: true,
    priority: 30,
    name: 'Image',
    image: '/common/cms/image-component.png',
    tags: ['image', 'big', 'banner'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: '',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'cta_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
